import { Home, LogIn } from "lucide-react";
import BlackListBooks from "../components/BlackListBooks";

export default function LandingPage() {
    return (
        <div>
             <nav className="fixed top-0 left-0 right-0 w-full bg-white shadow-md z-50">
                <div className="px-4 flex flex-wrap items-center justify-between w-full">   
                    <div
                        className="navbar-collapse offcanvas-collapse lg:flex lg:flex-grow lg:items-center w-full bg-white py-4 shadow-md"
                        style={{ backgroundColor: 'white', minHeight: '60px', border: 'none' }}
                        id="navbarsExampleDefault"
                    >
                        <img src="/logoprotekids.png" alt="ProteKids" width="200" className="h-auto ml-2" />
                        <ul className="ml-[-200px] mt-3 mb-2 flex flex-col list-none lg:mt-0 lg:mb-0 lg:flex-row lg:justify-center w-full">
                           
                            <li>
                                <a
                                    className="flex flex-row page-scroll font-semibold text-lg text-gray-800 transition-all duration-300 items-center gap-2 mr-4"
                                    onMouseEnter={(e) => (e.currentTarget.style.color = "#2294ae")}
                                    onMouseLeave={(e) => (e.currentTarget.style.color = "")}
                                    href="/landing">
                                    <Home size={20}/> Home 
                                </a>
                            </li>
                            <li>
                                <a
                                    className=" page-scroll font-semibold text-lg text-gray-800 transition-all duration-300 flex items-center gap-2"
                                    onMouseEnter={(e) => (e.currentTarget.style.color = "#2294ae")}
                                    onMouseLeave={(e) => (e.currentTarget.style.color = "")}
                                    href="/login">
                                   <LogIn size={20} /> Login
                                </a>
                            </li>
                        </ul>
                    </div>     
                </div> 
            </nav>

        <header id="header" className="header py-28 text-center md:pt-36 lg:text-left xl:pt-44 xl:pb-32">
            <div className="container px-4 sm:px-8 lg:grid lg:grid-cols-2 lg:gap-x-8">
                <div className="mb-16 lg:mt-32 xl:mt-40 xl:mr-12">
                    <h1 className="h1-large mb-5 text-[#2294ae]">Sobre o ProteKids</h1>
                    <p className="p-large mb-8 text-gray-700"><b>Bem-vindo ao ProteKids, sua solução inteligente para garantir uma leitura segura e enriquecedora para crianças e jovens!</b></p>
                    <p className="p-large mb-8 text-gray-700">
                        No ambiente educacional, a escolha de materiais de leitura é uma decisão crucial. Sabemos que o poder das palavras vai além do entretenimento – 
                        elas moldam pensamentos, inspiram ações, constroem valores, estando intimamente ligado à formação de cidadãos. <br /><br /> Por isso o ProteKids foi 
                        criado: para ajudar escolas, educadores e pais a oferecer livros que sejam não apenas educativos, mas também seguros e apropriados para jovens 
                        leitores.
                    </p>
                    <div className="flex space-x-4">
                        <a href="#your-link" className="transition-all duration-300 hover:opacity-80">
                            {/* <img src="/images/google_play_icon.png" alt="Google Play" className="w-40 h-auto" /> */}
                        </a>
                        <a href="#your-link" className="transition-all duration-300 hover:opacity-80">
                            {/* <img src="/images/app_store_icon.png" alt="App Store" className="w-40 h-auto" /> */}
                        </a>
                    </div>
                </div>
                <div className="xl:text-right flex items-center">
                    <img className="rounded-lg inline" src="images/book-1.jpg" alt="alternative" />
                </div>
            </div>
        </header> 


        <div className="footer">
            <div className="pt-4 pb-14 text-center">
                <div className="container px-4 sm:px-8 xl:px-4">
                    <h2 className="mb-4 text-[#2294ae] text-3xl leading-10 lg:max-w-5xl lg:mx-auto"><b>O que é o ProteKids?</b></h2>
                    <p className="mb-4 text-lg text-left">
                        O ProteKids é uma ferramenta tecnológica inovadora que utiliza inteligência artificial para avaliar livros infantojuvenis. Nosso sistema analisa o 
                        conteúdo textual de forma detalhada e identifica elementos de linguagem que possam ser inadequados, como:
                    </p>
                    <ul className="list-inside list-disc mb-7 space-y-2 pl-8">
                                <li className="text-left mb-2 text-lg text-[#6b747b]">Palavras de baixo calão;</li>
                                <li className="text-left mb-2 text-lg text-[#6b747b]">Expressões ofensivas;</li>
                                <li className="text-left mb-2 text-lg text-[#6b747b]">Violência explícita;</li>
                                <li className="text-left mb-2 text-lg text-[#6b747b]">Temas sensíveis não indicados para a faixa etária;</li>
                                <li className="text-left mb-2 text-lg text-[#6b747b]">Estereótipos ou mensagens que possam ser prejudiciais.</li>
                    </ul>
                    <p className="mb-4 text-lg text-left">Com o ProteKids, você pode ter a tranquilidade de saber que os livros selecionados são apropriados e alinhados aos valores da sua instituição. Ficando longe de livros polëmicos como os listados abaixo.</p>
                    <BlackListBooks />
                </div> 
            </div>

            <div id="details" className="pt-12 pb-16 lg:pt-16">
                <div className="container px-4 sm:px-8 lg:grid lg:grid-cols-12 lg:gap-x-12">
                    <div className="lg:col-span-5">
                        <div className="mb-16 lg:mb-0 xl:mt-16">
                            <h2 className="mb-6 text-2xl text-[#2294ae]">Como funciona?</h2>
                            <p className="mb-4 text-lg">A tecnologia por trás do ProteKids é alimentada por uma poderosa inteligência artificial.</p>
                            <p className="mb-4 text-lg">
                                Nossa plataforma realiza análises rápidas e precisas, destacando possíveis áreas de preocupação auxiliando na tomada de decisão para quais materiais devem ser 
                                incluídos na ementa e plano de ensino, sempre com foco na proteção e no desenvolvimento saudável dos jovens leitores.
                            </p>
                        </div>
                    </div> 
                    <div className="lg:col-span-7">
                        <div className="xl:ml-14">
                            <img className="rounded-lg inline" src="images/book-2.jpg" alt="alternative" />
                        </div>
                    </div> 
                </div> 
            </div>
        </div>

        <div className="header">
            <div className="py-12">
                <div className="container px-4 sm:px-0 lg:grid lg:grid-cols-12 lg:gap-x-12">
                    <div className="lg:col-span-5">
                        <div className="xl:mt-0">
                            <h2 className="mb-2 text-2xl text-[#2294ae]">Por que escolher o ProteKids?</h2>
                        </div>
                    </div> 
                </div> 
            </div>

            <div id="features" className="cards-1">
                <div className="container px-4 sm:px-8 xl:px-4 flex flex-wrap gap-4 justify-center">
                    <div className="card flex flex-col min-h-[300px]">
                        <div className="card-image">
                            <img src="images/cybersecurity.svg" alt="alternative" />
                        </div>
                        <div className="card-body flex-grow">
                            <h5 className="card-title text-xl font-semibold">Segurança Educacional</h5>
                            <p className="mb-4 text-lg">Crie um ambiente de aprendizado positivo e protegido. Forneça suporte confiável ao seu corpo docente.</p>
                        </div>
                    </div>

                    <div className="card flex flex-col min-h-[300px]">
                        <div className="card-image">
                            <img src="images/goal_471027.svg" alt="alternative" />
                        </div>
                        <div className="card-body flex-grow">
                            <h5 className="card-title text-xl font-semibold">Eficiência e Precisão</h5>
                            <p className="mb-4 text-lg">Economize tempo com análises automatizadas, confiáveis e baseadas em critérios educacionais sólidos.</p>
                        </div>
                    </div>

                    <div className="card flex flex-col min-h-[300px]">
                        <div className="card-image">
                            <img src="images/education.svg" alt="alternative" />
                        </div>
                        <div className="card-body flex-grow">
                            <h5 className="card-title text-xl font-semibold">Compromisso com a Educação</h5>
                            <p className="mb-4 text-lg">Trabalhamos ao lado de educadores, psicólogos, psicopedagogos e especialistas para garantir que nossa abordagem seja sempre ética e eficaz.</p>
                        </div>
                    </div>
                </div> 
            </div> 

            <div className="pt-16 pb-12">
                <div className="container px-4 sm:px-8 lg:grid lg:grid-cols-12 lg:gap-x-12">
                    <div className="lg:col-span-5">
                        <div className="mb-16 lg:mb-0 xl:mt-16">
                            <h2 className="mb-6 text-2xl text-[#2294ae]">Quem pode se beneficiar?</h2>
                            <p className="mb-4 text-lg">
                                O ProteKids é ideal para escolas, bibliotecas, editoras e qualquer organização que tenha como objetivo promover uma leitura consciente e 
                                segura para o público infantojuvenil. Mais do que proteger crianças e jovens leitores, o uso periódico da ferramenta beneficia as famílias, 
                                criando um ambiente de confiança e tranquilidade, que podem acompanhar a formação literária de seus filhos com a certeza de que estão 
                                expostos a conteúdos adequados.
                            </p>
                        </div>
                    </div> 
                    <div className="lg:col-span-7">
                        <div className="ml-14">
                            <img className="rounded-lg inline" src="images/book-3.jpg" alt="alternative" />
                        </div>
                    </div>
                </div>
            </div>

        </div>

        {/*
        <div id="pricing" className="cards-2">
            <div className="absolute bottom-0 h-40 w-full bg-white"></div>
            <div className="container px-4 pb-px sm:px-8">
                <h2 className="mb-2.5 text-white lg:max-w-xl lg:mx-auto">Planos acessíveis para todas as necessidades</h2>
                <p className="mb-16 text-white lg:max-w-3xl lg:mx-auto">
                    Oferecemos opções flexíveis, para que qualquer instituição ou responsável possa contar com nossa tecnologia sem comprometer o orçamento. 
                    Escolha o plano que melhor se adapta às suas necessidades e proporcione uma experiência de leitura mais segura e enriquecedora!
                </p>

                <div className="card">
                    <div className="card-body">
                        <div className="card-title">PLANO BÁSICO</div>
                        <div className="price"><span className="currency">$</span><span className="value">29</span></div>
                        <div className="frequency">por mês</div>
                        <p>This basic package covers the marketing needs of small startups</p>
                        <ul className="list mb-7 space-y-2 text-left">
                            <li className="flex">
                                <i className="fas fa-chevron-right"></i>
                                <div>ipsum lorem ipsum loren ipsum</div>
                            </li>
                        </ul>
                        <div className="button-wrapper">
                            <a className="btn-solid-reg page-scroll" href="#download">Download</a>
                        </div>
                    </div>
                </div> 
                <div className="card">
                    <div className="card-body">
                        <div className="card-title">PLANO AVANÇADO</div>
                        <div className="price"><span className="currency">$</span><span className="value">39</span></div>
                        <div className="frequency">por mês</div>
                        <p>This is a more advanced package suited for medium companies</p>
                        <ul className="list mb-7 space-y-2 text-left">
                            <li className="flex">
                                <i className="fas fa-chevron-right"></i>
                                <div>ipsum lorem ipsum loren ipsum</div>
                            </li>
                        </ul>
                        <div className="button-wrapper">
                            <a className="btn-solid-reg page-scroll" href="#download">Download</a>
                        </div>
                    </div>
                </div> 
                <div className="card">
                    <div className="card-body">
                        <div className="card-title">PLANO COMPLETO</div>
                        <div className="price"><span className="currency">$</span><span className="value">49</span></div>
                        <div className="frequency">por mês</div>
                        <p>This is a comprehensive package designed for big organizations</p>
                        <ul className="list mb-7 text-left space-y-2">
                            <li className="flex">
                                <i className="fas fa-chevron-right"></i>
                                <div>ipsum lorem ipsum loren ipsum</div>
                            </li>
                        </ul>
                        <div className="button-wrapper">
                            <a className="btn-solid-reg page-scroll" href="#download">Download</a>
                        </div>
                    </div>
                </div> 

            </div>
        </div>
        */}
       
        <div id="download" className="basic-5">
            <div className="container px-4 sm:px-8 lg:grid lg:grid-cols-2">
                <div className="mb-16 lg:mb-0">
                    <img className="rounded-lg" src="images/book-4.jpg" alt="alternative" />
                </div>
                <div className="lg:mt-24 xl:mt-44 xl:ml-12">
                    <p className="mb-9 text-gray-600 text-3xl leading-10 ">Começe a utilizar o <span className="text-[#2294ae] text-bold"> ProteKids </span> agora mesmo e tenha o primeiro ciclo acadêmico gratuito! </p>
                    <div className="flex space-x-4">
                        <a href="/signup" className="transition-all duration-300 hover:opacity-80 w-[200px]">
                            <button className="w-full py-2 bg-[#2294ae] text-white font-bold rounded-md hover:bg-[#1c7c92] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2294ae]">
                                Quero Utilizar!
                            </button>
                        </a>
                    </div>
                </div>
            </div>

        <div className="header">
            <div className="container px-4 sm:px-8">
                <h4 className="mb-8 lg:max-w-3xl lg:mx-auto">       </h4>
                <div className="social-container">
                    <span className="fa-stack">
                        <a href="#your-link">
                            <i className="fas fa-circle fa-stack-2x"></i>
                            <i className="fab fa-facebook-f fa-stack-1x"></i>
                        </a>
                    </span>
                    <span className="fa-stack">
                        <a href="#your-link">
                            <i className="fas fa-circle fa-stack-2x"></i>
                            <i className="fab fa-twitter fa-stack-1x"></i>
                        </a>
                    </span>
                    <span className="fa-stack">
                        <a href="#your-link">
                            <i className="fas fa-circle fa-stack-2x"></i>
                            <i className="fab fa-pinterest-p fa-stack-1x"></i>
                        </a>
                    </span>
                    <span className="fa-stack">
                        <a href="#your-link">
                            <i className="fas fa-circle fa-stack-2x"></i>
                            <i className="fab fa-instagram fa-stack-1x"></i>
                        </a>
                    </span>
                    <span className="fa-stack">
                        <a href="#your-link">
                            <i className="fas fa-circle fa-stack-2x"></i>
                            <i className="fab fa-youtube fa-stack-1x"></i>
                        </a>
                    </span>
                </div> 
            </div> 
        </div> 
        </div>
    </div>);
}